import { VendorContractPublic } from '../../../common/application/model/VendorContractPublic';

export function getGoogleMapsLinkForContract(contract: VendorContractPublic): string {
    const street = contract.vendorLocationStreet;
    const zip = contract.vendorLocationZip;
    const city = contract.vendorLocationCity;

    return `https://maps.google.com/?q=${street}, ${zip} ${city}`;
}
